export const pageSizeOptions = [10, 30, 50];
export const pageSizeEnumMap = {
  10: "TenEntries",
  30: "ThirtyEntries",
  50: "FiftyEntries"
}